import React from "react";
import About from "../components/Home/About";

function OurServices() {
  return (
    <div>
      <About />
    </div>
  );
}

export default OurServices;
